/* Kasanova Skin — theme behaviours */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || '${{amount}}';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const fix = (n, d, t = ',', dec = '.') => {
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(d);
      const parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? dec + parts[1] : '');
    };
    const m = fmt.match(re);
    let v = '';
    switch (m && m[1]) {
      case 'amount_no_decimals': v = fix(cents, 0); break;
      case 'amount_with_comma_separator': v = fix(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fix(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fix(cents, 2, "'"); break;
      default: v = fix(cents, 2);
    }
    return fmt.replace(re, v);
  }

  /* ---------- countdown ---------- */
  function initCountdowns(root = document) {
    $$('[data-ks-countdown]', root).forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const mode = el.dataset.mode;
      const getEnd = () => {
        const now = new Date();
        if (mode === 'fixed') { const d = new Date(el.dataset.end); return isNaN(d) ? new Date(now.getTime() + 864e5) : d; }
        if (mode === 'rolling') {
          const key = 'ks_cd_' + (el.dataset.hours || 24);
          let end;
          try { end = parseInt(localStorage.getItem(key), 10); } catch (e) {}
          if (!end || end < Date.now()) {
            end = Date.now() + (parseInt(el.dataset.hours, 10) || 24) * 36e5;
            try { localStorage.setItem(key, end); } catch (e) {}
          }
          return new Date(end);
        }
        const mid = new Date(now); mid.setHours(23, 59, 59, 999); return mid;
      };
      let end = getEnd();
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let diff = Math.max(0, end - new Date());
        if (diff === 0 && mode !== 'fixed') { end = getEnd(); diff = end - new Date(); }
        const s = Math.floor(diff / 1000);
        $('[data-d]', el).textContent = pad(Math.floor(s / 86400));
        $('[data-h]', el).textContent = pad(Math.floor((s % 86400) / 3600));
        $('[data-m]', el).textContent = pad(Math.floor((s % 3600) / 60));
        $('[data-s]', el).textContent = pad(s % 60);
      };
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- gallery ---------- */
  function initGallery(root) {
    const g = $('[data-ks-gallery]', root);
    if (!g || g.dataset.ready) return null;
    g.dataset.ready = '1';
    const slides = $$('.ks-gallery__slide', g);
    const thumbs = $$('[data-thumb]', g);
    let idx = 0;
    const go = (i) => {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === idx));
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === idx));
      const t = thumbs[idx]; if (t) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    };
    thumbs.forEach((t) => t.addEventListener('click', () => go(+t.dataset.thumb)));
    const p = $('[data-prev]', g), n = $('[data-next]', g);
    p && p.addEventListener('click', () => go(idx - 1));
    n && n.addEventListener('click', () => go(idx + 1));
    let x0 = null;
    const main = $('.ks-gallery__main', g);
    main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', (e) => {
      if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1)); x0 = null;
    });
    return { toMedia: (id) => { const i = slides.findIndex((s) => s.dataset.mediaId === String(id)); if (i > -1) go(i); } };
  }

  /* ---------- product buy box ---------- */
  function initPdp(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const moneyEl = $('[data-ks-money]', root);
    const moneyFormat = moneyEl ? JSON.parse(moneyEl.textContent) : '${{amount}}';
    const gallery = initGallery(root);
    const form = $('[data-ks-form]', root);
    const tiers = $$('[data-tier]', root);
    const atcPrice = $('[data-atc-price]', root);
    const stickyPrice = $('[data-sticky-price]', root);
    const err = $('[data-atc-error]', root);

    const selectedTier = () => tiers.find((t) => t.classList.contains('is-selected')) || tiers[0];
    const paidTotal = (tier) => $$('[data-scent]', tier)
      .filter((s) => s.dataset.paid === 'true')
      .reduce((sum, s) => {
        const opt = s.tagName === 'SELECT' ? s.selectedOptions[0] : s;
        return sum + (parseInt(opt.dataset.price, 10) || 0);
      }, 0);
    const refresh = () => {
      const t = selectedTier(); if (!t) return;
      const total = paidTotal(t);
      const txt = formatMoney(total, moneyFormat);
      const priceEl = $('[data-tier-price]', t); if (priceEl) priceEl.textContent = txt;
      if (atcPrice) atcPrice.textContent = txt;
      if (stickyPrice) stickyPrice.textContent = txt;
    };
    tiers.forEach((t) => {
      const radio = $('input[type="radio"]', t);
      t.addEventListener('click', (e) => {
        if (e.target.closest('select')) return;
        tiers.forEach((x) => x.classList.toggle('is-selected', x === t));
        if (radio) radio.checked = true;
        refresh();
      });
      $$('select[data-scent]', t).forEach((sel, i) => sel.addEventListener('change', () => {
        refresh();
        const media = sel.selectedOptions[0].dataset.media;
        if (gallery && media) gallery.toMedia(media);
      }));
    });
    refresh();

    form && form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const t = selectedTier(); if (!t) return;
      const btn = $('[data-atc]', form);
      const qty = {};
      const scents = $$('[data-scent]', t);
      const free = parseInt(t.dataset.free, 10) || 0;
      if (scents.length === 1 && scents[0].type === 'hidden') {
        const id = scents[0].value; qty[id] = (parseInt(t.dataset.buy, 10) || 1) + free;
      } else {
        scents.forEach((s) => { qty[s.value] = (qty[s.value] || 0) + 1; });
      }
      const items = Object.keys(qty).map((id) => ({ id: parseInt(id, 10), quantity: qty[id] }));
      const drawer = document.querySelector('cart-drawer');
      const body = { items };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      btn.setAttribute('disabled', ''); btn.setAttribute('aria-busy', 'true');
      err.classList.remove('is-visible');
      try {
        const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
        if (drawer && data.sections) {
          data.id = items[0].id;
          drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (ex) {
        err.textContent = ex.message; err.classList.add('is-visible');
      } finally {
        btn.removeAttribute('disabled'); btn.removeAttribute('aria-busy');
      }
    });

    /* delivery date */
    const del = $('[data-ks-delivery]', root);
    if (del) {
      const addBiz = (d, n) => { const r = new Date(d); let a = 0; while (a < n) { r.setDate(r.getDate() + 1); const w = r.getDay(); if (w !== 0 && w !== 6) a++; } return r; };
      const f = (d) => d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      const min = parseInt(del.dataset.min, 10) || 5, max = parseInt(del.dataset.max, 10) || 8;
      $('[data-date]', del).textContent = min === max ? f(addBiz(new Date(), max)) : f(addBiz(new Date(), min)) + ' – ' + f(addBiz(new Date(), max));
    }

    /* sticky */
    const sticky = $('[data-ks-sticky]', root);
    const atc = $('[data-atc]', root);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const below = en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', !en.isIntersecting && below && window.innerWidth < 990);
      }).observe(atc);
      $('[data-sticky-btn]', sticky).addEventListener('click', () => atc.scrollIntoView({ behavior: 'smooth', block: 'center' }));
    }
  }

  /* ---------- drawers ---------- */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open-drawer]');
    if (open) {
      const d = document.getElementById(open.dataset.openDrawer);
      if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      return;
    }
    const close = e.target.closest('[data-close-drawer]');
    if (close) {
      const d = close.closest('.ks-drawer');
      if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.ks-drawer.is-open').forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; });
  });

  /* ---------- count-up stats ---------- */
  function initStats(root = document) {
    const els = $$('[data-count-to]', root).filter((el) => !el.dataset.ready);
    if (!els.length) return;
    const run = (el) => {
      el.dataset.ready = '1';
      const to = parseFloat(el.dataset.countTo) || 0, suf = el.dataset.suffix || '';
      const t0 = performance.now(), dur = 1600;
      const step = (now) => {
        const p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(to * e) + suf;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } }), { threshold: .4 });
    els.forEach((el) => io.observe(el));
  }

  /* ---------- tabs ---------- */
  function initTabs(root = document) {
    $$('[data-ks-tabs]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      const tabs = $$('[data-tab]', wrap), panels = $$('[data-panel]', wrap);
      tabs.forEach((t) => t.addEventListener('click', () => {
        tabs.forEach((x) => { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); });
        panels.forEach((p) => { p.hidden = p.dataset.panel !== t.dataset.tab; });
      }));
    });
  }

  /* ---------- horizontal scroller nav ---------- */
  function initScrollers(root = document) {
    $$('[data-ks-scroller]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      const track = $('[data-track]', wrap);
      const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 16 : 300);
      const p = $('[data-prev]', wrap), n = $('[data-next]', wrap);
      p && p.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      n && n.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  }

  /* ---------- quick add (bestsellers) ---------- */
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('[data-ks-quickadd]');
    if (!f) return;
    e.preventDefault();
    const btn = $('button', f);
    const id = parseInt($('[name="id"]', f).value, 10);
    const drawer = document.querySelector('cart-drawer');
    const body = { items: [{ id, quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    btn.setAttribute('disabled', '');
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'Error');
      if (drawer && data.sections) { data.id = id; drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty'); drawer.renderContents(data); }
      else window.location.href = '/cart';
    } catch (ex) { alert(ex.message); }
    finally { btn.removeAttribute('disabled'); }
  });

  function initAll(root = document) {
    initCountdowns(root);
    $$('[data-ks-pdp]', root).forEach(initPdp);
    initStats(root); initTabs(root); initScrollers(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
